import { Sprite, Texture } from 'pixi.js';
import { SVG } from './svg-element';

// TODO - rename to CanvasElement/BaseElement
export class GlowElement extends SVG<
  {
    alpha: number;
    radius: number;
  },
  any
> {
  private _canvas: HTMLCanvasElement;
  private _ctx: CanvasRenderingContext2D;
  initElement() {
    const canvas = document.createElement('canvas');
    const size = this.config.radius * 2;
    canvas.height = size * 2;
    canvas.width = size * 2;

    const ctx = canvas.getContext('2d');

    this._canvas = canvas;
    this._ctx = ctx;

    this.drawGradient(); // draw initial gradient

    const texture = Texture.from(canvas);
    this._element = new Sprite(texture);
    this._element.anchor.set(0.5);
  }

  private drawGradient() {
    const size = this.config.radius * 2;
    const ctx = this._ctx;

    ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);

    const gradient = ctx.createRadialGradient(size, size, 0, size, size, size);
    gradient.addColorStop(
      0,
      `rgba(${this.hexToRgb(this.fill)},${this.config.alpha})`,
    );
    gradient.addColorStop(1, `rgba(${this.hexToRgb(this.fill)},0)`);

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
  }

  updateAttr(): void {
    if (this.x || this.y) {
      this.element.position.set(this.x, this.y);
    }

    this.drawGradient();

    // Update PIXI texture
    const baseTexture = this._element.texture.baseTexture;
    baseTexture.update(); // This tells PIXI to re-upload canvas changes
  }
  hexToRgb(hex) {
    // Remove leading '#' if present
    hex = hex.replace(/^#/, '');

    // Parse shorthand (e.g. #03F) to full form (e.g. #0033FF)
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(char => char + char)
        .join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `${r}, ${g}, ${b}`;
  }
}
